import { http } from "./http";
import { getPaginationRequestParams } from "../utils/paginationRequest";
import toast from "svelte-french-toast";
import CircoloNotFoundToast from "../components/Toasts/CircoloNotFoundToast.svelte";
import EmailAlreadyUsedToast from "../components/Toasts/EmailAlreadyUsedToast.svelte";
import CreateGenericErrorToast from "../components/Toasts/CreateGenericErrorToast.svelte";

export function getSubscribers(pagination) {
    return http.get(`v1/subscribers?${getPaginationRequestParams(pagination)}`);
}

export function deleteSubscriber(id) {
    return http.delete(`v1/subscribers/${id}`);
}

export function createSubscriberRegister(subscriber, groupId) {
    return http.post(`v1/subscribers/register${groupId ? `?groupId=${groupId}` : ""}`, {...subscriber});
}

export function updateSubscriber(subscriber, id, year) {
    return http.patch(`v1/subscribers/${id}`, {...subscriber}, {
        params: { year }
    });
}

export function getSubscriber(id) {
    return http.get(`v1/subscribers/${id}`);
}

export function activateMembership(subId, year, paidAmount, paidAt) {
    return http.post(`v1/subscribers/${subId}/memberships/${year}/activate`, undefined, {
        params: { paidAmount, paidAt }
    })
}
export function deactivateMembership(subId, year) {
    return http.post(`v1/subscribers/${subId}/memberships/${year}/deactivate`);
}

export function sendToken(email, template) {
    return http.post(`v1/subscribers/token?email=${email}&template=${template}`);
}

export function getSubByToken(token) {
    return http.get(`v1/subscribers/token/${token}`);
}

export function getSubscriberByEmail(email) {
    return http.get(`v1/subscribers/single/email`, { params: { email } });
}

export function subscribeMultiple(token, subscribers) {
    return http.post(`/v1/subscribers/register/multiple?token=${token}`, subscribers);
}

export function exportMembershipsToXLSX(membershipIds, notes, pagination) {
    const urlParams = new URLSearchParams();

    Object.keys(pagination ?? {}).forEach((key) => {
        urlParams.append(key, pagination[key]);
    });

    return http.post(`/v1/subscribers/export-membership?${urlParams}`,
        { membershipIds, notes }, {
        responseType: "blob",
    });
}


export function exportSubscribersToXLSX(pagination) {
    const urlParams = new URLSearchParams();

    Object.keys(pagination ?? {}).forEach((key) => {
        urlParams.append(key, pagination[key]);
    });

    return http.post(`/v1/subscribers/export-subscribers?${urlParams}`, {}, {
        responseType: "blob",
    });
}

// function createURLParams (firstName, lastName, email, referenceYear, gender, foreign, birthDateFrom, birthDateTo, nationality, residenceForeign, residenceRegion, residenceProvince, residenceCity, paymentMethod, membershipCreatedFrom, membershipCreatedTo, paymentDateFrom, paymentDateTo, wasPrinted) {
//     return new URLSearchParams({
//         ...insert(firstName, "firstName"),
//         ...insert(lastName, "lastName"),
//         ...insert(email, "email"),
//         ...insert(referenceYear, "referenceYear"),
//         ...insert(gender, "gender"),
//         ...insert(foreign, "foreign"),
//         ...insert(birthDateFrom, "birthDateFrom"),
//         ...insert(birthDateTo, "birthDateTo"),
//         ...insert(nationality, "nationality"),
//         ...insert(residenceForeign, "residenceForeign"),
//         ...insert(residenceRegion, "residenceRegion"),
//         ...insert(residenceProvince, "residenceProvince"),
//         ...insert(residenceCity, "residenceCity"),
//         ...insert(paymentMethod, "paymentMethod"),
//         ...insert(membershipCreatedFrom, "membershipCreatedFrom"),
//         ...insert(membershipCreatedTo, "membershipCreatedTo"),
//         ...insert(paymentDateFrom, "paymentDateFrom"),
//         ...insert(paymentDateTo, "paymentDateTo"),
//         ...insert(wasPrinted, "wasPrinted"),
//     });
// }
//
// function handlePaymentValue (pv) {
//     if(pv !== undefined && pv !== null) {
//        return pv === "true" ? "BANK" : "STRIPE";
//     } else {
//         return undefined;
//     }
// }

export function handleCreateError(err, isBackoffice) {
    switch (err.response.status) {
        case 404:
            toast.error(CircoloNotFoundToast);
            break;
        case 409:
            if (isBackoffice) {
                toast.error("Attenzione! Questa mail è stata già utilizzata da un altro iscritto!", { duration: 8000 });
            } else {
                toast.error(EmailAlreadyUsedToast, { duration: 8000 });
            }
            break;
        default:
            toast.error(CreateGenericErrorToast, { position: "top-center" });
    }
}
